module.exports = __webpack_public_path__ + "img/Nordeste.76a4522c.svg";